import React from 'react';
import PropTypes from 'prop-types';
import {Box, Drawer, Hidden, List, Typography, ListItem, makeStyles} from '@material-ui/core';
import {Link} from 'gatsby-theme-material-ui';
import clsx from 'clsx';
import NavItem from './NavItem';

const useStyles = makeStyles(theme => ({
  mobileDrawer: {
    width: 256,
  },
  desktopDrawer: {
    width: 256,
    top: 64,
    height: 'calc(100% - 64px)',
  },
  title: {
    fontWeight: 700,
  },
  navGroup: {
    marginBottom: theme.spacing(2),
    '&:last-child': {
      marginBottom: 0,
    },
  },
  navGroupTitle: {
    marginTop: theme.spacing(2),
    paddingBottom: 0,
  },
  itemActive: {
    color: theme.palette.primary.main,
    fontWeight: 1000,
  },
}));

const Navbar = ({onMobileClose, openMobile, navBarData, breadcrumbs}) => {
  const classes = useStyles();
  const content = (
    <Box height="100%" display="flex" flexDirection="column">
      <Box p={2} paddingBottom={0}>
        <Hidden mdUp>{breadcrumbs}</Hidden>
        <List>
          {navBarData.pages.map(page => (
            <div key={page.id}>
              <ListItem className={classes.navGroupTitle}>
                <Link to={page.url}>
                  <Typography
                    variant="button"
                    color="textSecondary"
                    className={clsx(classes.title, page.expanded ? classes.itemActive : '')}
                  >
                    {page.title}
                  </Typography>
                </Link>
              </ListItem>
              <List disablePadding className={classes.navGroup}>
                {page.sections.map(section => (
                  <NavItem
                    href={section.url}
                    key={section.id}
                    title={section.title}
                    expanded={page.expanded}
                  />
                ))}
              </List>
            </div>
          ))}
        </List>
      </Box>
      <Box flexGrow={1} />
    </Box>
  );

  return (
    <>
      <Hidden mdUp>
        <Drawer
          anchor="left"
          classes={{paper: classes.mobileDrawer}}
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
        >
          {content}
        </Drawer>
      </Hidden>
      <Hidden smDown>
        <Drawer anchor="left" classes={{paper: classes.desktopDrawer}} open variant="persistent">
          {content}
        </Drawer>
      </Hidden>
    </>
  );
};

Navbar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool,
};

Navbar.defaultProps = {
  onMobileClose: () => {},
  openMobile: false,
};

export default Navbar;
